import React from 'react';
import Svg, { Rect, Circle, Line, Defs, Path, Use, G } from 'react-native-svg';

const colors = ['green', 'blue', 'red', 'orange', 'magenta', 'brown', 'darkgrey', 'darkblue']

export default function SvgOverlay({ graph }) {
    // console.log('SVG', graph)
    const beg = 16;
    const step = 16;
    const width = 3;
    const frame = false;
    return (<Svg key={Math.random()} position='absolute' top={-8} left={-8} height='80px' width='80px' viewBox='0 0 128 128' shapeRendering='crispEdges' fill='white'>
        <Defs>
            <Path id="up" d="M 8 0 L 16 24 H 0 L8 0Z" />
            <Path id="do" d="M 8 24 L0 0 L 16 0 L 8 24Z" />
        </Defs>
        {frame && <Rect x='0' y='0' width='128' height='128' fill='white' stroke='black'/>}
        {graph.map((line, l) => {
            return (
                <G key={'G' + l} strokeLinecap='round' strokeWidth={width} stroke={colors[l]}>
                    {line.d && <>
                        <Line x1={beg + l * step} y1='64' x2={beg + l * step} y2='128' />
                        <Line x1={beg + l * step} y1='0' x2={beg + l * step} y2='64' />
                        <Use x={beg - 8 +l * step} y={32} fill={colors[l]} href="#do" />
                    </>}
                    {line.u && <>
                        <Line x1={beg + l * step} y1='128' x2={beg + l * step} y2='64' />
                        <Line x1={beg + l * step} y1='0' x2={beg + l * step} y2='64' />
                        <Use x={beg - 8 +l * step} y={72} fill={colors[l]} href="#up" />
                    </>}
                    {line.sd != undefined && <>
                        <Line x1={beg + l * step} y1='96' x2={beg + l * step} y2='128' />
                        <Line x1={beg + line.sd * step + 4} y1='68' x2={beg + l * step} y2='96' />
                        <Use x={beg - 8 +l * step} y={104} fill={colors[l]} href="#do" />
                    </>}
                    {line.su != undefined && <>
                        <Line x1={beg + l * step} y1='48' x2={beg + l * step} y2='0' />
                        <Line x1={beg + line.su * step + 4} y1='60' x2={beg + l * step} y2='48' />
                        <Use x={beg - 8 +l * step} fill={colors[l]} y={16} href="#up" />
                    </>}
                    {line.ju != undefined && <>
                        <Line x1={beg + l * step} y1='128' x2={beg + l * step} y2='96' />
                        <Line x1={beg + line.ju * step + 4} y1='68' x2={beg + l * step} y2='96' />
                        <Use x={beg - 8 +l * step} fill={colors[l]} y={96} href="#up" />
                    </>}
                    {line.jd != undefined && <>
                        <Line x1={beg + l * step} y1='0' x2={beg + l * step} y2='48' stroke={colors[line.jd]} />
                        <Line x1={beg + line.jd * step + 4} y1='60' x2={beg + l * step} y2='48' />
                        <Use x={beg - 8 +l * step} fill={colors[l]} y={16} href="#do" />
                    </>}
                    {line.b && <Line x1={beg + l * step} y1='64' x2={beg + l * step} y2='128' />}
                    {line.t && <Line x1={beg + l * step} y1='0' x2={beg + l * step} y2='64' />}
                    {line.m && <Circle cx={beg + l * step} cy='64' r='7' fill={colors[l]} />}
                </G>
            )
        })}
    </Svg>)
}